import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import useSetPdpSelectedProtectionPlanId from './useSetPdpSelectedProtectionPlanId';
const useResetPdpSelectedProtectionPlanId = () => {
  const $ = _c(2);
  const setPdpSelectedProtectionPlanId = useSetPdpSelectedProtectionPlanId();
  let t0;
  if ($[0] !== setPdpSelectedProtectionPlanId) {
    t0 = () => {
      setPdpSelectedProtectionPlanId(0);
    };
    $[0] = setPdpSelectedProtectionPlanId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resetPdpSelectedProtectionPlanId = t0;
  return resetPdpSelectedProtectionPlanId;
};
export default useResetPdpSelectedProtectionPlanId;